import React, {memo} from 'react';
import {View, Image, Platform} from 'react-native';

import { StyleSheet } from 'react-native';
import {colorPalette} from '../../../core/config/color.config';

import {Photo} from './../../server/types/photo.types';

import {SVGIcon} from './../../components';
import { width, height, totalSize } from 'react-native-dimension';
import UserImageWithStatus from './../../../assets/images/UserImageWithStatus.png';

interface ConsultationPhotoProps {
  size?: number;
  photo?: Photo;
  forConsultationList?: boolean
}

const ConsultationPhoto = ({size = 56, photo, forConsultationList = false}: ConsultationPhotoProps) => {
  

  return (
    <View
      style={[
        photo && styles.userIcon,
        !photo && styles.defaultUserIcon,
        {
          width: size,
          height: size,
          borderRadius: size,
        },
      ]}>
      {photo ? (
        <Image
          style={[
            styles.imageWrapper,
            {
              borderRadius: size,
            },
          ]} 
          source={{
            uri: photo.url,
          }}
        />
      ) : (
          forConsultationList ? (
            <Image source={UserImageWithStatus} style={{width: width(18), height: width(18)}} resizeMode='contain' />

          ) : (
            <Image source={UserImageWithStatus} style={{width: width(12), height: width(12)}} resizeMode='contain' />
          )
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  userIcon: {
    position: 'relative',
    backgroundColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: colorPalette.primary,
  },
  defaultUserIcon:{
    position: 'relative',
    backgroundColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: Platform.OS === 'ios' ? height(1.5) : height(0)
  },
  imageWrapper: {
    width: '100%',
    height: '100%',
  },
});

export default memo(ConsultationPhoto);
